import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {InsightsService} from "../../services/insights/insights.service";
import * as Highcharts from 'highcharts/highcharts';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {SolidgaugeChartService} from "../../services/solidgauge-chart/solidgauge-chart.service";
import HighchartsMore from "highcharts/highcharts-more";


HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-leaving',
  templateUrl: './leaving.component.pug',
  styleUrls: ['./leaving.component.scss'],
  standalone: false
})
export class LeavingComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;

  data: any = [];
  contractCompletion = 0
  careerProgression = 0
  personalReasons = 0
  redundancy = 0
  salary = 0
  companyEnvironment = 0
  dismissed = 0
  refusedToShare = 0
  location = 0
  flexibleWorkPractices = 0
  workload = 0
  healthAndSafety = 0
  unsatisfactoryWorkTasks = 0
  retirementStudy = 0
  Highcharts: typeof Highcharts = Highcharts;

  contractCompletionChartOptions;
  careerProgressionChartOptions;
  personalReasonsChartOptions;
  redundancyChartOptions;
  salaryChartOptions;
  companyEnvironmentChartOptions;
  dismissedChartOptions;
  refusedToShareChartOptions;
  locationChartOptions;
  flexibleWorkPracticesChartOptions;
  healthAndSafetyChartOptions;
  workloadChartOptions;
  unsatisfactoryWorkTasksChartOptions;
  retirementStudyChartOptions;

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,) {
  }

  ngOnInit(): void {
    this.setChartOptions();
  }

  private loadAndSetData() {
    this.insightsService.getReasonForLeaving(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {

      this.data = data;

      // Reset all data
      this.contractCompletion = this.careerProgression = this.personalReasons = this.redundancy = this.salary = this.companyEnvironment = this.dismissed = this.refusedToShare = this.location = this.flexibleWorkPractices = this.workload = this.healthAndSafety = this.unsatisfactoryWorkTasks = this.retirementStudy = 0

      for (let d of this.data) {
        if (d['reason'] === 'Contract completion') {
          this.contractCompletion = d['response']
        } else if (d['reason'] === 'Career progression') {
          this.careerProgression = d['response']
        } else if (d['reason'] === 'Personal reasons') {
          this.personalReasons = d['response']
        } else if (d['reason'] === 'Redundancy') {
          this.redundancy = d['response']
        } else if (d['reason'] === 'Salary') {
          this.salary = d['response']
        } else if (d['reason'] === 'Company environment') {
          this.companyEnvironment = d['response']
        } else if (d['reason'] === 'Dismissed') {
          this.dismissed = d['response']
        } else if (d['reason'] === 'Prefer not to say') {
          this.refusedToShare = d['response']
        } else if (d['reason'] === 'Location') {
          this.location = d['response']
        } else if (d['reason'] === 'Flexible work practices') {
          this.flexibleWorkPractices = d['response']
        } else if (d['reason'] === 'Workload') {
          this.workload = d['response']
        } else if (d['reason'] === 'Health and Safety') {
          this.healthAndSafety = d['response']
        } else if (d['reason'] === 'Unsatisfactory work tasks') {
          this.unsatisfactoryWorkTasks = d['response']
        } else if (d['reason'] === 'Retirement/Study') {
          this.retirementStudy = d['response']
        }
      }

      this.setChartOptions();
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  private setChartOptions() {
    this.contractCompletionChartOptions = SolidgaugeChartService.getOptions(this.contractCompletion, '#32735F', 'rgb(244,248,247)');
    this.careerProgressionChartOptions = SolidgaugeChartService.getOptions(this.careerProgression, '#DE8C02', 'rgb(253,249,242)');
    this.personalReasonsChartOptions = SolidgaugeChartService.getOptions(this.personalReasons, '#DE8C02', 'rgb(253,249,242)');
    this.redundancyChartOptions = SolidgaugeChartService.getOptions(this.redundancy, '#DE8C02', 'rgb(253,249,242)');
    this.salaryChartOptions = SolidgaugeChartService.getOptions(this.salary, '#DE8C02', 'rgb(253,249,242)');
    this.companyEnvironmentChartOptions = SolidgaugeChartService.getOptions(this.companyEnvironment, '#AF0001', 'rgb(250,242,242)');
    this.dismissedChartOptions = SolidgaugeChartService.getOptions(this.dismissed, '#AF0001', 'rgb(250,242,242)');
    this.refusedToShareChartOptions = SolidgaugeChartService.getOptions(this.refusedToShare, '#DE8C02', 'rgb(253,249,242)');
    this.locationChartOptions = SolidgaugeChartService.getOptions(this.location, '#DE8C02', 'rgb(253,249,242)');
    this.flexibleWorkPracticesChartOptions = SolidgaugeChartService.getOptions(this.flexibleWorkPractices, '#AF0001', 'rgb(250,242,242)');
    this.workloadChartOptions = SolidgaugeChartService.getOptions(this.workload, '#AF0001', 'rgb(250,242,242)');
    this.healthAndSafetyChartOptions = SolidgaugeChartService.getOptions(this.healthAndSafety, '#AF0001', 'rgb(250,242,242)');
    this.unsatisfactoryWorkTasksChartOptions = SolidgaugeChartService.getOptions(this.unsatisfactoryWorkTasks, '#AF0001', 'rgb(250,242,242)');
    this.retirementStudyChartOptions = SolidgaugeChartService.getOptions(this.retirementStudy, '#DE8C02', 'rgb(253,249,242)');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }

}
